module.exports = __webpack_public_path__ + "img/listattendanceteacher.95a41ffa.svg";